import classes from "./LoadingOverLoadedPage.module.css";

const LoadingOverLoadedPage = () => {
  return (
    <div id="loadingContainer" className={classes.spinnerBackdrop}>
      <h2>لطفا منتظر بمانید</h2>
      <h3>... درحال انجام عملیات</h3>
      <div className={classes.spinnerContainer}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default LoadingOverLoadedPage;
